<template>
	<el-dialog :title="$t('searchImageTip2')" :visible.sync="localVisible" width="900px" top="5vh" center
		class="upload-dialog" @close="handleClose">
		<div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
			<div class="upload-button">
				<button class="custom-upload-btn" @click="triggerFileInput">
					<i class="el-icon-upload" style="font-size: 24px;"></i>
					<span>{{$t('uploadImage')}}</span>
				</button>
				<input type="file" ref="fileMoreInput" class="file-input" accept="image/*" multiple
					@change="handleFileUpload" title="">
			</div>
			<div style="padding-top: 10px;color: #666;text-align: center;line-height: 20px;">{{$t('moreImageSearchTip')}}</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: 'uploadDialog',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				localVisible: this.visible,
				dialogVisible: false,
			}
		},
		watch: {
			visible(val) {
				this.localVisible = val;
			},
			localVisible(val) {
				this.$emit('update:visible', val);
			}
		},
		methods: {
			handleClose() {
				this.localVisible = false;
			},
			// 触发文件选择
			triggerFileInput() {
				this.$refs.fileMoreInput.click();
			},
			// 处理文件上传
			handleFileUpload(event) {
				const files = event.target.files;
				// 检查上传的图片数量
				if (files.length < 6) {
					// 提醒用户
					this.$message.warning(this.$t('minUpload'));
					// 清空已选的图片信息
					event.target.value = '';
					return;
				}
				
				// 处理文件并存储到sessionStorage
				const fileDataArray = [];
				
				// 处理每个文件
				for (let i = 0; i < files.length; i++) {
					const file = files[i];
					// 创建文件URL用于预览
					const imageUrl = URL.createObjectURL(file);
				
					// 创建文件数据对象
					const fileData = {
						url: imageUrl,
						name: file.name,
						size: file.size,
						type: file.type
					};
				
					fileDataArray.push(fileData);
				}
				
				// 存储文件数据到sessionStorage
				sessionStorage.setItem('uploadedFiles', JSON.stringify(fileDataArray));
				this.$router.push({
					path: '/product-search-more-image'
				});
			},
		}
	}
</script>

<style scoped>
	.upload-button {
		position: relative;
	}

	.custom-upload-btn {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 15px 20px;
		background-color: #D9001B;
		color: white;
		border: none;
		border-radius: 5px;
		cursor: pointer;
		font-size: 16px;
		transition: background-color 0.3s;
	}

	.custom-upload-btn:hover {
		background-color: #ff4400;
	}

	.file-input {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
		z-index: 1;
	}
</style>